module.exports = __webpack_public_path__ + "img/16_68.70f5ba16.png";